// Data Contracts
import { JudgeChamberTag } from '@data-contracts';

// Local
import { JudgeChamberTagOption } from '../models/judge-chambers-view.model';

/**
 * Maps chamber tag DTOs to UI models, dropping tags without an id or name and
 * sorting by name.
 *
 * @param tags The chamber tag DTOs.
 * @returns The chamber tags, sorted by name.
 */
export function mapChamberTags(
  tags: JudgeChamberTag[] | null | undefined,
): JudgeChamberTagOption[] {
  return (tags ?? [])
    .filter(tag => !!tag.tagId && !!tag.name)
    .map(tag => ({
      tagId: tag.tagId,
      name: tag.name,
      documentCount: tag.documentCount ?? 0,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
